export enum MessageType {
  Logout = 'Logout',
}
